export const Tickets = {
  purchase() {
    window.open(`https://www.tickettailor.com/events/eurorust/2022388`)
  }
}

export default Tickets;
